<template>
  <div class="login">
    <p class="register" @click="$router.push('/login')">登录</p>
    <h1 class="title">注册</h1>
    <LoginInput
      placeholderpaw="请输入验证码"
      :codeBtn="true"
      loginBtn="快速注册"
      :serviceFlag="true"
      @clickBtn="clickBtn"
    />
  </div>
</template>

<script>
import LoginInput from "../../components/LoginInput";
export default {
  name: "Register",
  data() {
    return {};
  },
  components: {
    LoginInput
  },
  methods: {
    clickBtn(obj) {
      // 1、判断滑块是否完成
      if (!obj.dragSuccess) {
        this.$toast("请拖动滑块完成验证");
        return;
      }
      // 2、判断是否勾选服务条款
      if (!obj.serviceCheck) {
        this.$toast("请勾选服务条款");
        return;
      }
      let data = {
        phone: obj.phone,
        smsCode: obj.paw
      };
      this.$store
        .dispatch("Register", data)
        .then(() => {
          this.$toast.success("注册成功");
          this.$router.push({ path: "/" });
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style>
</style>

<style lang="less" scoped>
.login {
  padding: 0 30px;
}
.register {
  text-align: right;
  padding-top: 55px;
  font-size: 30px;
  color: #666;
}
.title {
  font-size: 50px;
  margin: 95px 0 165px 0;
}
</style>